// Shared full-screen overlay for home-launched views (chat, plans).
// Portaled to document.body (the header's backdrop-filter would otherwise
// anchor position:fixed to itself) with body scroll locked while open.
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'var(--page-bg, #e9e7f7)',
  zIndex: 1500,
  overflowY: 'auto',
  padding: '20px 12px calc(20px + env(safe-area-inset-bottom))',
};

const sheetStyle = {
  maxWidth: 760,
  margin: '0 auto',
  background: 'var(--surface-1, #ffffff)',
  borderRadius: 24,
  boxShadow: 'var(--shadow-shell, 0 30px 80px -30px rgba(26,31,54,0.35))',
  padding: '24px 18px 40px',
  minHeight: 'calc(100vh - 40px)',
};

// `zIndex` lets a caller stack above other overlays (e.g. the legal pages
// must open on top of the auth modal at z-index 2000).
export default function FullPageOverlay({ label, zIndex, children }) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return createPortal(
    <div
      style={zIndex ? { ...overlayStyle, zIndex } : overlayStyle}
      role="dialog"
      aria-modal="true"
      aria-label={label}
    >
      <div style={sheetStyle}>{children}</div>
    </div>,
    document.body
  );
}
